import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SelectOption } from "../../shared/interfaces/select-option";
import { PortfolioService } from "../services/portfolio.service";

export const portfoliosResolver: ResolveFn<SelectOption[]> = () => {
    const service = inject(PortfolioService);
    return service.getPortfolios();
};